import { Link } from 'react-router-dom';

import { ArrowFullRightIcon, IconText } from '@motorway/mw-highway-code';

import type { PromoCardContentWrapperProps, PromoCardProps } from '../../PromoCards.types';

import styles from './PromoCard.scss';

const isExternalLink = (r: string) => /^https?:\/\//.test(r);

const PromoCardContentWrapper = ({
  children,
  link,
  onClick,
  rel,
  target,
}: Pick<PromoCardProps, 'link' | 'onClick'> & PromoCardContentWrapperProps) => (<>
  {
    isExternalLink(link)
      ? (
        <a
          {...{ onClick, rel, target }}
          data-thc-style-override
          href={link}
        >
          {children}
        </a>
      ) : (
        <Link
          {...{ onClick, rel, target }}
          data-thc-style-override
          to={link}
        >
          {children}
        </Link>
      )
  }
</>);

export const PromoCard = (
  {
    cta,
    description,
    img,
    link,
    onClick,
    ref,
    tag,
    theme = 'blue',
    title,
  }: PromoCardProps,
) => {
  const isExternal = isExternalLink(link);

  return (<div ref={ref} className={styles.component} data-testid='promoCard'>
    <PromoCardContentWrapper
      rel='noreferrer noopener'
      target={isExternal ? '_blank' : '_self'}
      {...{ isExternal, link, onClick }}
    >
      {img && (
        <picture>
          {img.src.avif && <source srcSet={img.src.avif} type="image/avif" />}
          {img.src.webp && <source srcSet={img.src.webp} type="image/webp" />}
          <img
            alt={img.alt}
            height={270}
            loading='lazy'
            src={img.src.png}
            width={316} />
        </picture>
      )}
      <div className={styles.content}>
        {tag && <span className={styles.tag} data-theme={theme}>{tag}</span>}
        <h3>{title}</h3>
        {description && <p className="mw-i">{description}</p>}
      </div>
      <IconText
        data-thc-icontext
        reverse
        icon={ArrowFullRightIcon}
        text={<span>{cta}</span>}
        variant="xsmall--regular" />
    </PromoCardContentWrapper>
  </div>);
};
